export default __webpack_public_path__ + "static/media/arrowLeftDark.dd4db822.svg";